import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestRankingFormFeedback from './TestRankingFormFeedback'
import TestRankingFormFonts from './TestRankingFormFont'
import TestRankingFormStyle from './TestRankingFormStyle'
import type { TestRankingFormBrandType, TestRankingBrandForms } from './testRankingTypes'

const FORM_MAP: TestRankingBrandForms = {
  [BrandFormEnum.STYLE]: TestRankingFormStyle,
  [BrandFormEnum.FEEDBACK]: TestRankingFormFeedback,
  ...TestRankingFormFonts,
}

const TestRankingFormBrand: TestRankingFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TestRankingFormBrand) as typeof TestRankingFormBrand
